export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00028.5d3bd81e.png";